import { Box } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ItemProps } from "react-virtuoso";
import { useGroupedVirtualizedContext } from "./context";

export const VirtuosoItem = forwardRef(function VirtuosoItem<D>(
  { children, ...props }: ItemProps<D>,
  ref?: Ref<HTMLDivElement>
) {
  const { slotProps } = useGroupedVirtualizedContext();

  return (
    <Box {...props} {...slotProps?.listItem} ref={ref}>
      {children}
    </Box>
  );
});
